import gql from "graphql-tag";

const bookCoreFragment = gql`
  fragment BookCore on Book {
    id
    _id
    title
    slug
    authors
    isbn
    imageUrl
    thumbnailUrl
    price
    format
    description
    unencryptedFilePath
    vatIncluded
    currency {
      id
      _id
    }
  }
`;

const bookDetailsFragment = gql`
  fragment BookDetails on Book {
    ...BookCore
  }
  ${bookCoreFragment}
`;

export default {
  bookCoreFragment,
  bookDetailsFragment,
};